import type { IconProps } from '@/components/CustomIcon/types';

export const OrganizationsIcon = ({
  size = 20,
  className,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M16.6749 9.15837H10.8416V7.4917H9.17493V9.15837H2.8916V12.4917H4.55827V10.825H9.17493V12.4917H10.8416V10.825H15.4249V12.4917H17.0916V9.15837H16.6749Z"
        fill="currentColor"
      />
      <path
        d="M10.0084 5.84172C11.159 5.84172 12.0917 4.90898 12.0917 3.75838C12.0917 2.60779 11.159 1.67505 10.0084 1.67505C8.85779 1.67505 7.92505 2.60779 7.92505 3.75838C7.92505 4.90898 8.85779 5.84172 10.0084 5.84172Z"
        fill="currentColor"
      />
      <path
        d="M3.72493 18.325C4.87553 18.325 5.80827 17.3923 5.80827 16.2417C5.80827 15.0911 4.87553 14.1583 3.72493 14.1583C2.57434 14.1583 1.6416 15.0911 1.6416 16.2417C1.6416 17.3923 2.57434 18.325 3.72493 18.325Z"
        fill="currentColor"
      />
      <path
        d="M10.0084 18.325C11.159 18.325 12.0917 17.3923 12.0917 16.2417C12.0917 15.0911 11.159 14.1583 10.0084 14.1583C8.85779 14.1583 7.92505 15.0911 7.92505 16.2417C7.92505 17.3923 8.85779 18.325 10.0084 18.325Z"
        fill="currentColor"
      />
      <path
        d="M16.2584 18.325C17.409 18.325 18.3417 17.3923 18.3417 16.2417C18.3417 15.0911 17.409 14.1583 16.2584 14.1583C15.1078 14.1583 14.175 15.0911 14.175 16.2417C14.175 17.3923 15.1078 18.325 16.2584 18.325Z"
        fill="currentColor"
      />
    </svg>
  );
};
